var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "home" },
    [
      _c("Headbar", {
        class: { full: _vm.offY > 580 },
        attrs: { type: "dft" },
      }),
      _vm._v(" "),
      _c("div", { ref: "wrapper", staticClass: "scroll-outer" }, [
        _c(
          "div",
          { ref: "innerscroll", staticClass: "inner-scroll" },
          [
            _c(
              "section",
              {
                ref: "loadintro",
                staticClass: "dft-section main-intro",
                class: { active: !_vm.Global.lockScreen },
                style: [
                  _vm.Global.lockScreen
                    ? { top: _vm.introTop + "px", transform: "translateY(0)" }
                    : {
                        top: _vm.introTop + "px",
                        transform: "translateY(" + -_vm.introTop + "px)",
                      },
                ],
              },
              [
                _c("div", { staticClass: "hex-wrapper" }, [
                  _c("div", { staticClass: "col" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "hex hex-5" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".03",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "hex hex-3" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".05",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-4" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".05",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "hex hex-3" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".03",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-2" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".1",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-4" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".06",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-2b" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".05",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-1" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "in" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "90",
                              height: "91",
                              viewBox: "0 0 90 91",
                              fill: "none",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M58.2681 21.7235L44.8801 35.9149L31.1386 21.3417C30.4951 20.6556 30.2548 19.6875 30.4981 18.7837C30.5881 16.8968 31.0503 15.0472 31.856 13.3418L23.4584 4.91484C23.4285 4.88629 23.3998 4.85745 23.3713 4.82738C22.3402 3.74377 22.3818 2.02948 23.4653 0.997566M58.2681 21.7235C59.0049 21.2094 59.4395 20.3594 59.4206 19.4564C59.4188 17.3184 58.9385 15.2103 58.0175 13.2854L66.4006 4.90229L66.4069 4.89564C67.4388 3.81199 67.3973 2.09704 66.3134 1.06493C65.267 0.068628 63.6226 0.0686052 62.5762 1.06491L62.5696 1.07125L54.7697 8.87113C49.2484 3.75313 40.6634 3.7385 35.1234 8.91205L27.2893 1.08363C26.2566 0.00697649 24.5461 -0.0321421 23.4653 0.997566M44.9611 10.4481C40.3235 10.4829 36.4769 14.0019 35.9999 18.5809L44.8802 28.0148L53.9266 18.403C53.3661 13.8927 49.5391 10.4695 44.9611 10.4481Z",
                                fill: "#191818",
                              },
                            }),
                            _vm._v(" "),
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M63.6644 20.9348L85.0589 42.3354L85.1387 42.36L85.2704 42.4917C91.491 48.713 91.491 58.7999 85.2704 65.0212C79.0492 71.2424 68.9621 71.2424 62.7409 65.0212L60.9499 63.2302V68.8522C60.9499 76.508 57.3686 81.8841 53.7369 85.3562C50.1312 88.8034 46.4478 90.4048 46.0598 90.561L46.0553 90.5628L45.0224 90.9911L43.9742 90.5601L43.971 90.5587C43.6318 90.4174 39.9333 88.8186 36.3088 85.3564C32.6743 81.8846 29.0864 76.5085 29.0864 68.8522V63.2363L27.2954 65.0273C21.0655 71.2572 10.965 71.2572 4.73518 65.0273C1.90383 62.196 0.358808 58.5633 0.101414 54.8596L0.0996094 54.8337V52.6608L0.101414 52.6348C0.358808 48.9312 1.90383 45.2985 4.73518 42.4671L24.3554 22.8469L24.3621 22.8406C25.4085 21.8443 27.0528 21.8443 28.0992 22.8406C29.1831 23.8727 29.2246 25.5877 28.1927 26.6713L28.1864 26.678L8.57234 46.292C4.69406 50.357 4.69599 56.7533 8.57812 60.816C12.5887 65.0128 19.2405 65.166 23.4397 61.1595L41.1287 43.4705L35.6106 37.9523L16.6071 56.9557C16.5772 56.9869 16.5485 57.0149 16.5291 57.0337L16.5202 57.0424C15.4366 58.0742 13.7216 58.0327 12.6895 56.9488C11.6599 55.8675 11.6989 54.1578 12.7758 53.1249L35.6097 30.2911L45.501 40.1499L46.8661 41.5396L46.8708 41.5443L48.2666 42.9401L66.4679 61.1659C70.5735 65.2831 77.2399 65.2921 81.3572 61.1863C85.4737 57.0807 85.4829 50.4146 81.3772 46.2974L63.6646 28.6028L58.1462 34.1212L77.2299 53.205L77.2362 53.2116C78.2681 54.2953 78.2266 56.0102 77.1427 57.0423C76.0615 58.0719 74.3518 58.0329 73.3189 56.9561L50.4779 34.1213L63.6644 20.9348ZM35.2029 73.8775C37.1852 80.2642 42.6058 83.7792 44.9655 85.0399C47.3206 83.7787 52.7409 80.2637 54.7282 73.8775H35.2029ZM34.4563 68.4585H55.4755V61.0638H34.4563V68.4585ZM36.7646 55.6447H53.1619L44.9658 47.3276L36.7646 55.6447Z",
                                fill: "#191818",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-3" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".1",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-5" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".12",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-4" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".09",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-3" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".03",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-3" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".03",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-4" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".05",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-4" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".05",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-5" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".05",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }, [
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hex hex-5" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "204",
                            height: "185",
                            viewBox: "0 0 204 185",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              opacity: ".03",
                              d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                              fill: "url(#grt)",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "content" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("p", { staticClass: "txt-ctr" }, [
                      _vm._v(
                        "Discover Bee, the cloud video platform that manages your video & audio content and allows monetization and distribution worldwide."
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn main lrg min-lrg",
                        attrs: { href: "" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.scrollToNeeds.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "hvr" }),
                        _vm._v(" "),
                        _c("span", { staticClass: "txt" }, [
                          _vm._v("Try for free"),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "SectionPage",
              {
                staticClass: "dft-section preview-intro",
                on: {
                  inactivesection: function ($event) {
                    return _vm.inactive(["video1"])
                  },
                  activesection: function ($event) {
                    return _vm.active(["video1"])
                  },
                },
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "preview dft-up" }, [
                    _c("div", { staticClass: "vid-wrapper" }, [
                      _c(
                        "video",
                        {
                          ref: "video1",
                          attrs: {
                            width: "1440",
                            height: "850",
                            muted: "",
                            loop: "",
                            playsinline: "",
                          },
                          domProps: { muted: true },
                        },
                        [
                          _c("source", {
                            attrs: {
                              type: "video/mp4",
                              src: "/video/video1.mp4",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("SectionPage", { staticClass: "dft-section intro" }, [
              _c("div", { staticClass: "container" }, [
                _c("h2", { staticClass: "h1 title" }, [
                  _c("span", { staticClass: "txt-grt dft-up" }, [
                    _vm._v("Powerful features"),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "dft-up" }, [
                    _vm._v("to enrich your video platform"),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "SectionPage",
              {
                staticClass: "dft-section interface",
                on: {
                  inactivesection: function ($event) {
                    return _vm.inactive(["video2"])
                  },
                  activesection: function ($event) {
                    return _vm.active(["video2"])
                  },
                },
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "card-block" }, [
                    _c("div", { staticClass: "sect-bg" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "vid-wrapper" }, [
                      _c(
                        "video",
                        {
                          ref: "video2",
                          attrs: {
                            width: "1440",
                            height: "818",
                            muted: "",
                            loop: "",
                            playsinline: "",
                          },
                          domProps: { muted: true },
                        },
                        [
                          _c("source", {
                            attrs: {
                              type: "video/mp4",
                              src: "/video/video2.mp4",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inner-content container" }, [
                      _c("div", { staticClass: "sub-title" }, [
                        _c("h4", { staticClass: "dft-up" }, [
                          _c("span", [_vm._v("Create your own")]),
                          _vm._v(" "),
                          _c("span", { staticClass: "txt-grt" }, [
                            _vm._v("end-user experience"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v("with an easy & visual approach"),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "SectionPage",
              {
                staticClass: "dft-section bus-content",
                on: {
                  inactivesection: function ($event) {
                    return _vm.inactive(["video3", "video4"])
                  },
                  activesection: function ($event) {
                    return _vm.active(["video3", "video4"])
                  },
                },
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "card-block split" }, [
                    _c("div", { staticClass: "inner-card-block" }, [
                      _c("div", { staticClass: "sect-bg" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "vid-wrapper" }, [
                        _c(
                          "video",
                          {
                            ref: "video3",
                            attrs: {
                              width: "1440",
                              height: "818",
                              muted: "",
                              loop: "",
                              playsinline: "",
                            },
                            domProps: { muted: true },
                          },
                          [
                            _c("source", {
                              attrs: {
                                type: "video/mp4",
                                src: "/video/video3.mp4",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inner-content container" }, [
                        _c("div", { staticClass: "sub-title" }, [
                          _c("h4", { staticClass: "dft-up" }, [
                            _c("span", [_vm._v("Choose")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "txt-grt" }, [
                              _vm._v("your business model"),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("and your payment platforms")]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inner-card-block" }, [
                      _c("div", { staticClass: "sect-bg" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "vid-wrapper" }, [
                        _c(
                          "video",
                          {
                            ref: "video4",
                            attrs: {
                              width: "1440",
                              height: "818",
                              muted: "",
                              loop: "",
                              playsinline: "",
                            },
                            domProps: { muted: true },
                          },
                          [
                            _c("source", {
                              attrs: {
                                type: "video/mp4",
                                src: "/video/video4.mp4",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inner-content container" }, [
                        _c("div", { staticClass: "sub-title" }, [
                          _c("h4", { staticClass: "dft-up" }, [
                            _c("span", { staticClass: "txt-grt" }, [
                              _vm._v("Reserve your content to your community."),
                            ]),
                            _vm._v(" "),
                            _c("span", [_vm._v("World class DRM protection")]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "SectionPage",
              {
                staticClass: "dft-section crystal",
                on: {
                  inactivesection: function ($event) {
                    return _vm.inactive(["video5"])
                  },
                  activesection: function ($event) {
                    return _vm.active(["video5"])
                  },
                },
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "card-block" }, [
                    _c("div", { staticClass: "sect-bg" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "vid-wrapper" }, [
                      _c(
                        "video",
                        {
                          ref: "video5",
                          attrs: {
                            width: "1440",
                            height: "818",
                            muted: "",
                            loop: "",
                            playsinline: "",
                          },
                          domProps: { muted: true },
                        },
                        [
                          _c("source", {
                            attrs: {
                              type: "video/mp4",
                              src: "/video/video5.mp4",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inner-content container" }, [
                      _c("div", { staticClass: "sub-title" }, [
                        _c("h4", { staticClass: "dft-up" }, [
                          _c("span", { staticClass: "txt-grt" }, [
                            _vm._v("Crystal-clear quality of your videos."),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Because we cherish your art")]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "SectionPage",
              {
                staticClass: "dft-section moni-gift",
                on: {
                  inactivesection: function ($event) {
                    return _vm.inactive(["video6", "video7"])
                  },
                  activesection: function ($event) {
                    return _vm.active(["video6", "video7"])
                  },
                },
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "card-block split" }, [
                    _c("div", { staticClass: "inner-card-block" }, [
                      _c("div", { staticClass: "sect-bg" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "vid-wrapper" }, [
                        _c(
                          "video",
                          {
                            ref: "video6",
                            attrs: {
                              width: "1440",
                              height: "818",
                              muted: "",
                              loop: "",
                              playsinline: "",
                            },
                            domProps: { muted: true },
                          },
                          [
                            _c("source", {
                              attrs: {
                                type: "video/mp4",
                                src: "/video/video6.mp4",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inner-content container" }, [
                        _c("div", { staticClass: "sub-title" }, [
                          _c("h4", { staticClass: "dft-up" }, [
                            _c("span", [_vm._v("Create your dashboards to")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "txt-grt" }, [
                              _vm._v("monitor your success"),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "inner-card-block" }, [
                      _c("div", { staticClass: "sect-bg" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "vid-wrapper" }, [
                        _c(
                          "video",
                          {
                            ref: "video7",
                            attrs: {
                              width: "1440",
                              height: "818",
                              muted: "",
                              loop: "",
                              playsinline: "",
                            },
                            domProps: { muted: true },
                          },
                          [
                            _c("source", {
                              attrs: {
                                type: "video/mp4",
                                src: "/video/video7.mp4",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "inner-content container" }, [
                        _c("div", { staticClass: "sub-title" }, [
                          _c("h4", { staticClass: "dft-up" }, [
                            _c("span", [_vm._v("Promote your content to")]),
                            _vm._v(" "),
                            _c("span", { staticClass: "txt-grt" }, [
                              _vm._v("engage your users"),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("SectionPage", { staticClass: "dft-section unified" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "card-block" }, [
                  _c("div", { staticClass: "sect-bg" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "visu-outer" }, [
                    _c("div", { staticClass: "ctn pic desk" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ctn pic tab" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "ctn pic mob" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inner-content container" }, [
                    _c("div", { staticClass: "sub-title" }, [
                      _c("h4", { staticClass: "dft-up" }, [
                        _c("span", [_vm._v("Provide an")]),
                        _vm._v(" "),
                        _c("span", { staticClass: "txt-grt" }, [
                          _vm._v("unified suscriber experience"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sub-content" }, [
                      _c("div", { staticClass: "cat-wrap dft-up" }, [
                        _c("span", { staticClass: "txt-grt cap ft-xbld" }, [
                          _vm._v("Mobile & Tablet"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "icos-out" }, [
                          _c("img", {
                            staticClass: "and",
                            attrs: {
                              src: "/img/devices/android.png",
                              alt: "android logo",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/img/devices/apple.png",
                              alt: "apple logo",
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cat-wrap dft-up" }, [
                        _c("span", { staticClass: "txt-grt cap ft-xbld" }, [
                          _vm._v("Smart TVs"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "icos-out" }, [
                          _c("img", {
                            staticClass: "ap-tv",
                            attrs: {
                              src: "/img/devices/apple_tv.png",
                              alt: "apple tv logo",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "and",
                            attrs: {
                              src: "/img/devices/android_tv.png",
                              alt: "android tv logo",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/img/devices/lg_samsung.png",
                              alt: "lg samsung logo",
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "cat-wrap dft-up" }, [
                        _c("span", { staticClass: "txt-grt cap ft-xbld" }, [
                          _vm._v("Any web browser"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "icos-out" }, [
                          _c("img", {
                            attrs: {
                              src: "/img/devices/chrome.png",
                              alt: "chrome logo",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/img/devices/ie.png",
                              alt: "ie logo",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/img/devices/safari.png",
                              alt: "safari logo",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/img/devices/firefox.png",
                              alt: "firefox logo",
                            },
                          }),
                          _vm._v(" "),
                          _c("img", {
                            attrs: {
                              src: "/img/devices/brave.png",
                              alt: "brave logo",
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "SectionPage",
              { ref: "needs", staticClass: "dft-section needs" },
              [
                _c("div", { staticClass: "container" }, [
                  _c("h2", { staticClass: "h1 title" }, [
                    _c("span", { staticClass: "dft-up" }, [
                      _vm._v("Join our video lovers community"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "hammer",
                          rawName: "v-hammer:swipe",
                          value: _vm.onSwipe,
                          expression: "onSwipe",
                          arg: "swipe",
                        },
                      ],
                      staticClass: "needs-wrapper dft-up",
                    },
                    [
                      _c("div", { staticClass: "container k-mb" }, [
                        _c("div", { staticClass: "needs-inner" }, [
                          _c("div", { staticClass: "highlighter" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pre-table" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "caption ft-xbld" }, [
                                  _vm._v("Nurse"),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("The best to start distributing "),
                                  _c("br", { staticClass: "k-t" }),
                                  _vm._v("your content without risk"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn main",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.choosePackage("nurse")
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "hvr" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "txt" }, [
                                      _vm._v("Try for free"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "caption ft-xbld" }, [
                                  _vm._v("Architect"),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("Build your own "),
                                  _c("br", { staticClass: "k-t" }),
                                  _vm._v("content distribution platform"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn main",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.choosePackage("architect")
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "hvr" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "txt" }, [
                                      _vm._v("Try for free"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "caption ft-xbld" }, [
                                  _vm._v("Guardian"),
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v("Fast-growing rock-solid "),
                                  _c("br", { staticClass: "k-t" }),
                                  _vm._v("content anywhere platform"),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn main",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.choosePackage("guardian")
                                      },
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "hvr" }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "txt" }, [
                                      _vm._v("Try for free"),
                                    ]),
                                  ]
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "table ft-xbld" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("Active customer"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("1000"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("2000"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("5000"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("Video website"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("Content Delivery Network (CDN)"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("1TB"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("2TB"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("5TB"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("Storage"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("1TB"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("2TB"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("5TB"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("Transcoding per month"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("20h"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("40h"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("100h"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("In app payment"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content void" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("Mobile app’s"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content void" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("Smart TV app"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content void" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content void" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("24/7 support"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content void" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content void" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _c("span", { staticClass: "check" }, [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "26",
                                        height: "26",
                                        viewBox: "0 0 30 30",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("circle", {
                                        attrs: {
                                          cx: "15",
                                          cy: "15",
                                          r: "15",
                                          fill: "url(#grt)",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "7",
                                          y: "14.6064",
                                          width: "3",
                                          height: "10",
                                          transform: "rotate(-45 7 14.6064)",
                                          fill: "#191818",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("rect", {
                                        attrs: {
                                          x: "22.5562",
                                          y: "8.94971",
                                          width: "3",
                                          height: "15",
                                          transform:
                                            "rotate(45 22.5562 8.94971)",
                                          fill: "#191818",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "item" }, [
                                _vm._v("Service-level agreement (SLA)"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content void" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content void" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content" }, [
                                _vm._v("99,99%"),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "post-table ft-xbld" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "switcher" }, [
                                _c(
                                  "span",
                                  {
                                    class: { active: !_vm.isYearly },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.changePricing.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("Monthly")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "switch",
                                    class: { tgld: _vm.isYearly },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.changePricing.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        attrs: {
                                          width: "56",
                                          height: "32",
                                          viewBox: "0 0 70 40",
                                          fill: "none",
                                        },
                                      },
                                      [
                                        _c("rect", {
                                          staticClass: "bk-rect",
                                          attrs: {
                                            opacity: "0.15",
                                            width: "70",
                                            height: "40",
                                            rx: "20",
                                            fill: "white",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("rect", {
                                          staticClass: "dot",
                                          attrs: {
                                            x: "4",
                                            y: "4",
                                            width: "32",
                                            height: "32",
                                            rx: "16",
                                            fill: "url(#grdt)",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "defs",
                                          [
                                            _c(
                                              "linearGradient",
                                              {
                                                attrs: {
                                                  id: "grdt",
                                                  x1: "36",
                                                  y1: "36",
                                                  x2: "1.29206",
                                                  y2: "32.7284",
                                                  gradientUnits:
                                                    "userSpaceOnUse",
                                                },
                                              },
                                              [
                                                _c("stop", {
                                                  attrs: {
                                                    "stop-color": "#F3CA54",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("stop", {
                                                  attrs: {
                                                    offset: "1",
                                                    "stop-color": "#FFBB36",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    class: { active: _vm.isYearly },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.changePricing.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v("Yearly "),
                                    _c("br"),
                                    _vm._v("(10% off)"),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content txt-grt" }, [
                                _c("span", [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.percentage(
                                          _vm.Global.products.nurse.price
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v("€"),
                                ]),
                                _vm._v(
                                  "\n                                            /month\n                                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content txt-grt" }, [
                                _c("span", [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.percentage(
                                          _vm.Global.products.architect.price
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v("€"),
                                ]),
                                _vm._v(
                                  "\n                                            /month\n                                        "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "content txt-grt" }, [
                                _c("span", [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.percentage(
                                          _vm.Global.products.guardian.price
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v("€"),
                                ]),
                                _vm._v(
                                  "\n                                            /month\n                                        "
                                ),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "m-needs-wrapper s-mb",
                          style: {
                            transform:
                              "translateX(calc(" +
                              -100 * this.mActiveCard +
                              "% - " +
                              20 * this.mActiveCard +
                              "px)",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "need-card",
                              class: { active: _vm.mActiveCard == 0 },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.needsCardToggle(0)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "pre-table" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "content" }, [
                                    _c(
                                      "span",
                                      { staticClass: "caption ft-xbld" },
                                      [_vm._v("Nurse")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "l-outer" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "btn main",
                                            attrs: {
                                              tag: "a",
                                              to: "/configurator",
                                            },
                                          },
                                          [
                                            _c("span", { staticClass: "txt" }, [
                                              _vm._v("Try for free"),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "table ft-xbld" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Active customer"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("1000"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Video website"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Content Delivery Network (CDN)"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("1TB"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Storage"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("1TB"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Transcoding per month"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("20h"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("In app payment"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content void" }, [
                                    _vm._v("-"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Mobile app’s"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content void" }, [
                                    _vm._v("-"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Smart TV app"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content void" }, [
                                    _vm._v("-"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("24/7 support"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content void" }, [
                                    _vm._v("-"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Service-level agreement (SLA)"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content void" }, [
                                    _vm._v("-"),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "post-table ft-xbld" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "switcher" }, [
                                    _c(
                                      "span",
                                      {
                                        class: { active: !_vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Monthly")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "switch",
                                        class: { tgld: _vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "56",
                                              height: "32",
                                              viewBox: "0 0 70 40",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("rect", {
                                              staticClass: "bk-rect",
                                              attrs: {
                                                opacity: "0.15",
                                                width: "70",
                                                height: "40",
                                                rx: "20",
                                                fill: "white",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("rect", {
                                              staticClass: "dot",
                                              attrs: {
                                                x: "4",
                                                y: "4",
                                                width: "32",
                                                height: "32",
                                                rx: "16",
                                                fill: "url(#gradt)",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "defs",
                                              [
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id: "gradt",
                                                      x1: "36",
                                                      y1: "36",
                                                      x2: "1.29206",
                                                      y2: "32.7284",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                    },
                                                  },
                                                  [
                                                    _c("stop", {
                                                      attrs: {
                                                        "stop-color": "#F3CA54",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "1",
                                                        "stop-color": "#FFBB36",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class: { active: _vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v("Yearly "),
                                        _c("br"),
                                        _vm._v("(10% off)"),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "content txt-grt" },
                                    [
                                      _c("span", [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.percentage(
                                                _vm.Global.products.nurse.price
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v("€"),
                                      ]),
                                      _vm._v(
                                        "\n                                            /month\n                                        "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "need-card",
                              class: { active: _vm.mActiveCard == 1 },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.needsCardToggle(1)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "pre-table" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "content" }, [
                                    _c(
                                      "span",
                                      { staticClass: "caption ft-xbld" },
                                      [_vm._v("Architect")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "l-outer" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "btn main",
                                            attrs: {
                                              tag: "a",
                                              to: "/configurator",
                                            },
                                          },
                                          [
                                            _c("span", { staticClass: "txt" }, [
                                              _vm._v("Try for free"),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "table ft-xbld" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Active customer"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("2000"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Video website"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Content Delivery Network (CDN)"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("2TB"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Storage"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("2TB"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Transcoding per month"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("40h"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("In app payment"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Mobile app’s"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Smart TV app"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content void" }, [
                                    _vm._v("-"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("24/7 support"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content void" }, [
                                    _vm._v("-"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Service-level agreement (SLA)"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content void" }, [
                                    _vm._v("-"),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "post-table ft-xbld" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "switcher" }, [
                                    _c(
                                      "span",
                                      {
                                        class: { active: !_vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Monthly")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "switch",
                                        class: { tgld: _vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "56",
                                              height: "32",
                                              viewBox: "0 0 70 40",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("rect", {
                                              staticClass: "bk-rect",
                                              attrs: {
                                                opacity: "0.15",
                                                width: "70",
                                                height: "40",
                                                rx: "20",
                                                fill: "white",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("rect", {
                                              staticClass: "dot",
                                              attrs: {
                                                x: "4",
                                                y: "4",
                                                width: "32",
                                                height: "32",
                                                rx: "16",
                                                fill: "url(#gradt)",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "defs",
                                              [
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id: "gradt",
                                                      x1: "36",
                                                      y1: "36",
                                                      x2: "1.29206",
                                                      y2: "32.7284",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                    },
                                                  },
                                                  [
                                                    _c("stop", {
                                                      attrs: {
                                                        "stop-color": "#F3CA54",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "1",
                                                        "stop-color": "#FFBB36",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class: { active: _vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v("Yearly "),
                                        _c("br"),
                                        _vm._v("(10% off)"),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "content txt-grt" },
                                    [
                                      _c("span", [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.percentage(
                                                _vm.Global.products.architect
                                                  .price
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v("€"),
                                      ]),
                                      _vm._v(
                                        "\n                                            /month\n                                        "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "need-card",
                              class: { active: _vm.mActiveCard == 2 },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.needsCardToggle(2)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "pre-table" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "content" }, [
                                    _c(
                                      "span",
                                      { staticClass: "caption ft-xbld" },
                                      [_vm._v("Guardian")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "l-outer" },
                                      [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "btn main",
                                            attrs: {
                                              tag: "a",
                                              to: "/configurator",
                                            },
                                          },
                                          [
                                            _c("span", { staticClass: "txt" }, [
                                              _vm._v("Try for free"),
                                            ]),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "table ft-xbld" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Active customer"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("5000"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Video website"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Content Delivery Network (CDN)"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("5TB"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Storage"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("5TB"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Transcoding per month"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("100h"),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("In app payment"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Mobile app’s"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Smart TV app"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("24/7 support"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _c("span", { staticClass: "check" }, [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "26",
                                            height: "26",
                                            viewBox: "0 0 30 30",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("circle", {
                                            attrs: {
                                              cx: "15",
                                              cy: "15",
                                              r: "15",
                                              fill: "url(#grt)",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "7",
                                              y: "14.6064",
                                              width: "3",
                                              height: "10",
                                              transform:
                                                "rotate(-45 7 14.6064)",
                                              fill: "#191818",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("rect", {
                                            attrs: {
                                              x: "22.5562",
                                              y: "8.94971",
                                              width: "3",
                                              height: "15",
                                              transform:
                                                "rotate(45 22.5562 8.94971)",
                                              fill: "#191818",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "item" }, [
                                    _vm._v("Service-level agreement (SLA)"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "content" }, [
                                    _vm._v("99,99%"),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "post-table ft-xbld" }, [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "switcher" }, [
                                    _c(
                                      "span",
                                      {
                                        class: { active: !_vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Monthly")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "switch",
                                        class: { tgld: _vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "56",
                                              height: "32",
                                              viewBox: "0 0 70 40",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("rect", {
                                              staticClass: "bk-rect",
                                              attrs: {
                                                opacity: "0.15",
                                                width: "70",
                                                height: "40",
                                                rx: "20",
                                                fill: "white",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c("rect", {
                                              staticClass: "dot",
                                              attrs: {
                                                x: "4",
                                                y: "4",
                                                width: "32",
                                                height: "32",
                                                rx: "16",
                                                fill: "url(#gradt)",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "defs",
                                              [
                                                _c(
                                                  "linearGradient",
                                                  {
                                                    attrs: {
                                                      id: "gradt",
                                                      x1: "36",
                                                      y1: "36",
                                                      x2: "1.29206",
                                                      y2: "32.7284",
                                                      gradientUnits:
                                                        "userSpaceOnUse",
                                                    },
                                                  },
                                                  [
                                                    _c("stop", {
                                                      attrs: {
                                                        "stop-color": "#F3CA54",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("stop", {
                                                      attrs: {
                                                        offset: "1",
                                                        "stop-color": "#FFBB36",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        class: { active: _vm.isYearly },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.changePricing.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v("Yearly "),
                                        _c("br"),
                                        _vm._v("(10% off)"),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "content txt-grt" },
                                    [
                                      _c("span", [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.percentage(
                                                _vm.Global.products.guardian
                                                  .price
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v("€"),
                                      ]),
                                      _vm._v(
                                        "\n                                            /month\n                                        "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("SectionPage", { staticClass: "dft-section more" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "content" }, [
                  _c("div", { staticClass: "sect-bg" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "inner-content container" }, [
                    _c("h3", { staticClass: "txt-blk title" }, [
                      _c("span", { staticClass: "dft-up" }, [
                        _vm._v("You need more ?"),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "dft-up" }, [
                        _vm._v("We have customized solution !"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "btm dft-up" }, [
                      _c("p", { staticClass: "txt-blk" }, [
                        _vm._v(
                          "Discover the unlimited possibilities of our software and platforms. Manage specific monetization needs & advanced user experience to differentiate your offer from your competitors."
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        { staticClass: "btn drk lrg", attrs: { href: "" } },
                        [
                          _c("span", { staticClass: "txt" }, [
                            _vm._v("Contact our experts"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("SectionPage", { staticClass: "dft-section swarm" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "content" }, [
                  _c("h2", { staticClass: "h1 title dft-up-m" }, [
                    _c("span", { staticClass: "dft-up" }, [
                      _vm._v("They are already part"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "dft-up" }, [
                      _vm._v("of the "),
                      _c("span", { staticClass: "txt-grt" }, [
                        _vm._v("bee swarm"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "txt-ctr dft-up" }, [
                    _vm._v(
                      "More than 120 companies trust our services every day with a total of +100 Millions views every days. Why not you?"
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hex-wrapper" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex hex8" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "grt",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#F3CA54" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#FFBB36",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex3" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#ble)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "ble",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#01A8CF" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#00CFFF",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/sooner.png",
                          alt: "sooner logo",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex hex9" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex9" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex3" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#aa)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "aa",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#483439" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#37292E",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/opsis.png",
                          alt: "opsis logo",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex2" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex7" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#bb)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "bb",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#FFFFFF" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#CCCCCC",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/tenk.png",
                          alt: "tenk logo",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex5" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#cc)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "cc",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#F5C851" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#FFBC39",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: { src: "/img/companies/ls.png", alt: "ls logo" },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex hex5" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex4" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#dd)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "dd",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#ED6A2C" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#DD5312",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: { src: "/img/companies/rx.png", alt: "rx logo" },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex6" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#ee)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "ee",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#282FC9" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#1C119C",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/glish.png",
                          alt: "glish logo",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex5" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#deca)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "deca",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#2CA5EC" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#1482C2",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/decathlon.png",
                          alt: "decathlon logo",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex hex2" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex1" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "90",
                            height: "91",
                            viewBox: "0 0 90 91",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M58.2681 21.7235L44.8801 35.9149L31.1386 21.3417C30.4951 20.6556 30.2548 19.6875 30.4981 18.7837C30.5881 16.8968 31.0503 15.0472 31.856 13.3418L23.4584 4.91484C23.4285 4.88629 23.3998 4.85745 23.3713 4.82738C22.3402 3.74377 22.3818 2.02948 23.4653 0.997566M58.2681 21.7235C59.0049 21.2094 59.4395 20.3594 59.4206 19.4564C59.4188 17.3184 58.9385 15.2103 58.0175 13.2854L66.4006 4.90229L66.4069 4.89564C67.4388 3.81199 67.3973 2.09704 66.3134 1.06493C65.267 0.068628 63.6226 0.0686052 62.5762 1.06491L62.5696 1.07125L54.7697 8.87113C49.2484 3.75313 40.6634 3.7385 35.1234 8.91205L27.2893 1.08363C26.2566 0.00697649 24.5461 -0.0321421 23.4653 0.997566M44.9611 10.4481C40.3235 10.4829 36.4769 14.0019 35.9999 18.5809L44.8802 28.0148L53.9266 18.403C53.3661 13.8927 49.5391 10.4695 44.9611 10.4481Z",
                              fill: "#191818",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              "clip-rule": "evenodd",
                              d: "M63.6644 20.9348L85.0589 42.3354L85.1387 42.36L85.2704 42.4917C91.491 48.713 91.491 58.7999 85.2704 65.0212C79.0492 71.2424 68.9621 71.2424 62.7409 65.0212L60.9499 63.2302V68.8522C60.9499 76.508 57.3686 81.8841 53.7369 85.3562C50.1312 88.8034 46.4478 90.4048 46.0598 90.561L46.0553 90.5628L45.0224 90.9911L43.9742 90.5601L43.971 90.5587C43.6318 90.4174 39.9333 88.8186 36.3088 85.3564C32.6743 81.8846 29.0864 76.5085 29.0864 68.8522V63.2363L27.2954 65.0273C21.0655 71.2572 10.965 71.2572 4.73518 65.0273C1.90383 62.196 0.358808 58.5633 0.101414 54.8596L0.0996094 54.8337V52.6608L0.101414 52.6348C0.358808 48.9312 1.90383 45.2985 4.73518 42.4671L24.3554 22.8469L24.3621 22.8406C25.4085 21.8443 27.0528 21.8443 28.0992 22.8406C29.1831 23.8727 29.2246 25.5877 28.1927 26.6713L28.1864 26.678L8.57234 46.292C4.69406 50.357 4.69599 56.7533 8.57812 60.816C12.5887 65.0128 19.2405 65.166 23.4397 61.1595L41.1287 43.4705L35.6106 37.9523L16.6071 56.9557C16.5772 56.9869 16.5485 57.0149 16.5291 57.0337L16.5202 57.0424C15.4366 58.0742 13.7216 58.0327 12.6895 56.9488C11.6599 55.8675 11.6989 54.1578 12.7758 53.1249L35.6097 30.2911L45.501 40.1499L46.8661 41.5396L46.8708 41.5443L48.2666 42.9401L66.4679 61.1659C70.5735 65.2831 77.2399 65.2921 81.3572 61.1863C85.4737 57.0807 85.4829 50.4146 81.3772 46.2974L63.6646 28.6028L58.1462 34.1212L77.2299 53.205L77.2362 53.2116C78.2681 54.2953 78.2266 56.0102 77.1427 57.0423C76.0615 58.0719 74.3518 58.0329 73.3189 56.9561L50.4779 34.1213L63.6644 20.9348ZM35.2029 73.8775C37.1852 80.2642 42.6058 83.7792 44.9655 85.0399C47.3206 83.7787 52.7409 80.2637 54.7282 73.8775H35.2029ZM34.4563 68.4585H55.4755V61.0638H34.4563V68.4585ZM36.7646 55.6447H53.1619L44.9658 47.3276L36.7646 55.6447Z",
                              fill: "#191818",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex4" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#ff)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "ff",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#FF488F" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#F3005E",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/mediawan.png",
                          alt: "mediawan logo",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex hex6" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".04",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex7" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#gg)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "gg",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#D3D3D3" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#FFFFFF",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/nos.png",
                          alt: "nos logo",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex3" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#hh)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "hh",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#3CB3F5" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#37A1D4",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/bouygues.png",
                          alt: "bouygues logo",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex2" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#bb)",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img cine" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/cinetek.png",
                          alt: "cinetek logo",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex hex9" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex5" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#ii)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "ii",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#23CF5D" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#29AC56",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/gremio.png",
                          alt: "gremio logo",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex1" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#bein)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "bein",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#7F4AB2" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#5F318C",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/bein.png",
                          alt: "bein logo",
                        },
                      }),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex hex8" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex2" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex3" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#jj)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "jj",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#C32020" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#8F1515",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/freaks.png",
                          alt: "freaks logo",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex hex7" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex5" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#kk)",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "defs",
                          [
                            _c(
                              "linearGradient",
                              {
                                attrs: {
                                  id: "kk",
                                  x1: "168.52",
                                  y1: "175.385",
                                  x2: "13.5029",
                                  y2: "144.083",
                                  gradientUnits: "userSpaceOnUse",
                                },
                              },
                              [
                                _c("stop", {
                                  attrs: { "stop-color": "#F9BB73" },
                                }),
                                _vm._v(" "),
                                _c("stop", {
                                  attrs: {
                                    offset: "1",
                                    "stop-color": "#EA9B52",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/cesar.png",
                          alt: "cesar logo",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex hex4" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#bb)",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "in w-img" }, [
                      _c("img", {
                        attrs: {
                          src: "/img/companies/reworld.png",
                          alt: "reworld logo",
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("SectionPage", { staticClass: "dft-section try" }, [
              _c("div", { staticClass: "hex-wrapper" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".1",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".05",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "hex" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "204",
                          height: "185",
                          viewBox: "0 0 204 185",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            opacity: ".03",
                            d: "M192.657 65.3865C199.402 77.068 202.774 82.9088 203.44 89.2506C203.659 91.3354 203.659 93.4375 203.44 95.5223C202.774 101.864 199.402 107.705 192.657 119.386L170.63 157.538C163.886 169.22 160.514 175.061 155.355 178.809C153.659 180.041 151.838 181.092 149.923 181.945C144.098 184.538 137.353 184.538 123.865 184.538L79.8106 184.538C66.3219 184.538 59.5775 184.538 53.7521 181.945C51.837 181.092 50.0166 180.041 48.3206 178.809C43.1618 175.061 39.7896 169.22 33.0452 157.538L11.0182 119.386C4.2738 107.705 0.901622 101.864 0.235072 95.5223C0.015956 93.4375 0.0159561 91.3354 0.235072 89.2506C0.901622 82.9088 4.2738 77.068 11.0182 65.3865L33.0452 27.2345C39.7896 15.5529 43.1618 9.71208 48.3206 5.96396C50.0166 4.73178 51.837 3.68075 53.7521 2.8281C59.5775 0.234468 66.3219 0.234468 79.8106 0.234469L123.865 0.23447C137.353 0.234471 144.098 0.234471 149.923 2.82811C151.838 3.68076 153.659 4.73178 155.355 5.96396C160.514 9.71209 163.886 15.5529 170.63 27.2345L192.657 65.3865Z",
                            fill: "url(#grt)",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "content" }, [
                  _c("h2", { staticClass: "h1 title" }, [
                    _c("span", { staticClass: "dft-up" }, [
                      _vm._v("Give it a try"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "txt-grt dft-up" }, [
                      _vm._v(" For free"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "txt-ctr dft-up" }, [
                    _vm._v(
                      "Discover Bee, the cloud video platform that manages your video & audio content and allows monetization and distribution worldwide."
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "btn main lrg min-lrg dft-up",
                      attrs: { href: "" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.scrollToNeeds.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "hvr" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "txt" }, [
                        _vm._v("Try for free"),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("Footbar"),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", {
        ref: "pointerMask",
        staticClass: "m",
        class: { "no-pointer": !_vm.Global.lockScreen },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "h1 title" }, [
      _c("span", {}, [_vm._v("The cloud video platform")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }